import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

import { computed, onMounted, ref } from "vue";
import router from "./router";
import { useStore } from "vuex";
import axios from "axios";
import { useI18n } from "vue-i18n";
import { showConsoleError } from "@/functions/errors";
import { TOKEN } from "@/constants/labels";
// COMPONENTS
import AppBar from "@/components/SmartLink/bars/AppBar.vue";
import SnackBarNotif from "@/components/PrincipalComponents/SnackBarNotif.vue";
import Snack_Bar from "@/components/PrincipalComponents/Snack_Bar.vue";
import DrawerBar from "@/components/SmartLink/bars/DrawerBar.vue";
import FloatingButton from "@/components/PrincipalComponents/FloatingButton.vue";

// CONSTANTS
import { APIS_TOPOLOGY, TIMEOUTTIME } from "./constants/apis";
import { LABELS } from "@/constants/labels";
import TopBar from "./components/RAOS/Bars/TopBar.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { t } = useI18n();
const projectName = computed(() => store.state.projectName);
const isRAOS = computed(() => projectName.value === "SmartLinkRAOS");
// const isCananea = computed(() => projectName.value === "SmartLinkCananea");


//==================================================//
//==================== VARIABLES ===================//
//==================================================//

/**
 * Vue / Vuetify
 */
const store = useStore();
const viewPage = computed(() => store.state.appBarPage);

onMounted(async () => {
  const pageStatus = ref(1);


  await axios
    .get(APIS_TOPOLOGY.value.getAllTopoData, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then(() => {
      pageStatus.value = 1;
    })
    .catch(function (error) {
      pageStatus.value = 0;
      store.commit("showSnackBar", {
        type: LABELS.error,
        msg: t("snackbar.errorApis"),
        valor: true,
      });
      showConsoleError(error);
    });

  if (pageStatus.value === 0) {
    localStorage.removeItem("user");
    router.push("/maintenance");
    store.commit("setAppBarPage", "maintenancePage");
  } else {
    router.push(`/login`)
    store.commit('setAppBarPage','loginPage');
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      (viewPage.value === 'smartlinkPage')
        ? (_openBlock(), _createBlock(_component_v_app_bar, {
            key: 0,
            elevation: 0,
            color: "background"
          }, {
            default: _withCtx(() => [
              (isRAOS.value)
                ? (_openBlock(), _createBlock(TopBar, { key: 0 }))
                : _createCommentVNode("", true),
              (!isRAOS.value)
                ? (_openBlock(), _createBlock(AppBar, { key: 1 }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_main, {
        class: _normalizeClass(
        viewPage.value !== 'smartlinkPage' ? 'login-styles__demo' : 'home-styles'
      )
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view),
          (viewPage.value === 'smartlinkPage' && !isRAOS.value)
            ? (_openBlock(), _createBlock(_component_v_sheet, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(DrawerBar)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class"]),
      _createElementVNode("div", null, [
        _createVNode(SnackBarNotif),
        _createVNode(Snack_Bar)
      ]),
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(FloatingButton)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})